import { Component } from '@angular/core';
import { ICellRendererAngularComp, IHeaderAngularComp } from 'ag-grid-angular';
import { ICellRendererParams, IHeaderParams } from 'ag-grid-community';
import { IoniconsOutline } from '@pt/pt-models';

@Component({
  selector: 'pt-lock-formatter-renderer',
  template: `
    <pt-icon *ngIf='params?.value' [key]='IconLock' class='checked'></pt-icon>
  `,
  styles: [`
    .checked {
      opacity: 1;
      color: var(--bs-dark);
    }
  `]
})
export class LockFormatterRendererComponent implements ICellRendererAngularComp, IHeaderAngularComp {

  IconLock = IoniconsOutline.lock;
  params: any;

  agInit(params: any): void {
    this.params = params;
  }

  refresh(params: ICellRendererParams): boolean;
  refresh(params: IHeaderParams): boolean;
  refresh(params: ICellRendererParams | IHeaderParams): boolean {
    return false;
  }

}
